export const WORDS_ONLY_REGEX =
  /^[a-zA-ZçÇğĞıİöÖşŞüÜ]+(?:[-' çÇğĞıİöÖşŞüÜ][a-zA-ZçÇğĞıİöÖşŞüÜ]+)*(\s)?$/;

export const NUMBER_ONLY_REGEX = /^\d+$/;

export const VALID_EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

export const PRICE_REGEX = /^[+-]?\d+(\.\d+)?$/;
